var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgH4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 428 524",
    style: {
      enableBackground: "new 0 0 428 524"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ffffff;stroke-width:0;stroke-miterlimit:10;}\r\n\t.st1{fill:#ffffff;stroke-width:0;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.6,96.4c21.2,0,38.5,17.3,38.5,38.5s-17.3,38.5-38.5,38.5s-38.5-17.3-38.5-38.5S44.4,96.4,65.6,96.4   M94.5,183h-6.8c-13.6,6.3-29.8,6.6-44.1,0h-6.8c-16,0-28.9,12.9-28.9,28.9v81.8c0,7.9,6.5,14.4,14.4,14.4h9.7v81.8  c0,7.9,6.5,14.4,14.4,14.4h38.5c7.9,0,14.4-6.5,14.4-14.4v-81.8h9.7c7.9,0,14.4-6.5,14.4-14.4v-81.8C123.4,195.9,110.4,183,94.5,183  z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.3,96.4c21.2,0,38.5,17.3,38.5,38.5s-17.3,38.5-38.5,38.5s-38.5-17.3-38.5-38.5S176.1,96.4,197.3,96.4   M226.2,183h-6.8c-13.6,6.3-29.8,6.6-44.1,0h-6.8c-16,0-28.9,12.9-28.9,28.9v81.8c0,7.9,6.5,14.4,14.4,14.4h9.7v81.8  c0,7.9,6.5,14.4,14.4,14.4h38.5c7.9,0,14.4-6.5,14.4-14.4v-81.8h9.7c7.9,0,14.4-6.5,14.4-14.4v-81.8  C255.1,195.9,242.2,183,226.2,183z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.8,219.5c12.7,0,23.1,10.4,23.1,23.1c0,12.7-10.4,23.1-23.1,23.1c-12.7,0-23.1-10.4-23.1-23.1  C284.7,229.9,295,219.5,307.8,219.5 M325.1,271.5H321c-8.2,3.8-17.9,3.9-26.5,0h-4.1c-9.6,0-17.3,7.8-17.3,17.3v49.1  c0,4.8,3.9,8.6,8.6,8.6h5.8v49.1c0,4.8,3.9,8.6,8.6,8.6h23.1c4.8,0,8.6-3.9,8.6-8.6v-49.1h5.8c4.8,0,8.6-3.9,8.6-8.6v-49.1  C342.5,279.3,334.7,271.5,325.1,271.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.4,219.5c12.7,0,23.1,10.4,23.1,23.1c0,12.7-10.4,23.1-23.1,23.1c-12.7,0-23.1-10.4-23.1-23.1  C365.3,229.9,375.7,219.5,388.4,219.5 M405.7,271.5h-4.1c-8.2,3.8-17.9,3.9-26.5,0h-4.1c-9.6,0-17.3,7.8-17.3,17.3v49.1  c0,4.8,3.9,8.6,8.6,8.6h5.8v49.1c0,4.8,3.9,8.6,8.6,8.6h23.1c4.8,0,8.6-3.9,8.6-8.6v-49.1h5.8c4.8,0,8.6-3.9,8.6-8.6v-49.1  C423.1,279.3,415.3,271.5,405.7,271.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH4);
export default __webpack_public_path__ + "static/media/h4.80be100790ad22db05a49f5b38a7fbb8.svg";
export { ForwardRef as ReactComponent };